import React from 'react';

interface IContext {
  root: React.RefObject<HTMLDivElement> | null;
}

export const IntersectionObserverContext: React.Context<IContext> =
  React.createContext<IContext>({
    root: null,
  });

type Props = React.PropsWithChildren<{
  root: IContext['root'];
}>;

/**
 * Simple context that receives a React Ref to be provided to components
 * lower in the tree/hierarchy to overwrite the default observable root
 * element used by the `useIntersectionObserver` hook.
 * Not using this on higher levels in the app will cause the hook to
 * default to the document's viewport.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const IntersectionObserverProvider: React.FC<Props> = (props: Props) => {
  const { children, root } = props;

  return (
    <IntersectionObserverContext.Provider value={{ root }}>
      {children}
    </IntersectionObserverContext.Provider>
  );
};
